<template>
   <section>
      <div class="role">
         <div class="roleRight">
            <div class="roleRight_Top" style="display: block">
               <template v-if="searchShow">
                  <el-input
                          clearable
                          v-model="search.searchKey"
                          clas="input_search"
                          placeholder="搜索昵称、openid"
                          @keyup.enter.native="getserviceList"
                          style="margin-right: 10px"
                  ></el-input>
                  <el-button size="medium" type="primary" @click="getserviceList(1)"
                  >查询
                  </el-button
                  >
               </template>
            </div>
            <div class="roleRight_Container public-table-data">
               <el-table
                       :data="tableData"
                       size="medium"
                       border
                       style="width: 100%"
                       row-key="customerServiceId"
                       v-loading="loading"
               >
                  <el-table-column label="序号" type="index" width="120">
                  </el-table-column>
                  <el-table-column prop="head" label="头像" width="120">
                     <template slot-scope="scope">
                        <el-image
                                v-if="scope.row.head"
                                style="width: 50px; height: 50px;border-radius: 50%"
                                :src="scope.row.head"
                                fit="cover"
                        ></el-image>
                     </template>
                  </el-table-column>
                  <el-table-column prop="name" label="昵称" width="160"></el-table-column>
                  <el-table-column prop="phone" label="手机号" width="160"></el-table-column>
                   <el-table-column prop="account" label="openid" width="180"></el-table-column>
                   <el-table-column prop="sex" label="性别" width="100">
                       <template slot-scope="scope">
                          <span>{{scope.sex==1?'男':'女'}}</span>
                       </template>
                   </el-table-column>
                  <el-table-column prop="status" label="状态" width="70">
                     <template slot-scope="scope">
                        <el-switch
                                :disabled="false"
                                v-model="scope.row.status"
                                :active-value="1"
                                :inactive-value="0"
                        ></el-switch>
                     </template>
                  </el-table-column>
                 <el-table-column prop="appName" label="注册应用" width="120"> </el-table-column>
                   <el-table-column prop="ctime" label="注册渠道" width="120">
                    <template slot-scope="scope">
                      <span>{{scope.row.channelName}} ({{scope.row.channelCode}})</span>
                    </template>
                   </el-table-column>
                  <el-table-column fixed="right" label="操作" width="70">
                     <template slot-scope="scope">
                        <el-button
                                @click="getOrderDetail(scope.row)"
                                type="text"
                                size="small"
                                v-if="detailShow"
                        >详情</el-button
                        >
                     </template>
                  </el-table-column>
               </el-table>
            </div>
         </div>
      </div>
   </section>
</template>
<script>
   export default {
      data() {
         return {
            tableData: [], //顶顶那列表
            loading: false,
            search: {
               searchKey: ''
            },
            searchShow: false,
            downShow: false,
            detailShow: false,
            qrcodeShow: false,

         };
      },
      mounted() {
         // this.getserviceList();
         this.getPermissionButtonList()
      },
      watch: {},
      methods: {
         getPermissionButtonList() {
            let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
            let arr = JSON.parse(PermissionButtonList)
            if (arr.length) {
               arr.map(item => {
                  if (item.code == 'kefu:user:query') {
                     this.searchShow = true
                  }
                  if (item.code == "kefu:user:detail") {
                     this.detailShow = true
                  }

               })
            }
         },
         //订单列表
         async getserviceList(e) {
            this.loading = true;
            const {data: res} = await this.$get(
                    `/kefu/user/list?searchKey=` + this.search.searchKey,
                    {
                       headers: {
                          isLoading: true,
                       },
                    }
            );
            this.loading = false;
            let list = res.data
            if (list) {
               list.forEach((item) => {
                  item.orderMoney = item.orderMoney / 100
                  item.payMoney = item.payMoney / 100
               })
            }
            this.tableData = list;
         },
         //订单详情
         getOrderDetail(row) {
            this.$router.push({
               name: "ORDER_DETAIL",
               query: {
                  id: 6,
                  title: "用户列表",
                  key: "userId",
                  value: JSON.stringify(row.userId),
                  path: "/user/info",
               },
            });
         },
      },
   };
</script>

<style lang="scss" scoped>
   .role {
      display: flex;
      gap: 20px;
      color: #666; /** 公共的黑色 --暂定 */
      font-size: 14px;

      &Right {
         flex: 1;
         display: flex;
         flex-direction: column;
         overflow-x: hidden;

         &_Top {
            display: flex;
            gap: 15px;

            .el-input {
               width: auto;
            }

            .timeblock {
               display: flex;
               box-sizing: border-box;
               background: #fff;
               border: 1px solid #dcdfe6;
               border-radius: 5px;

               .cla ::v-deep .el-input--suffix .el-input__inner {
                  padding-right: 0;
               }

               ::v-deep .el-input__inner {
                  border: none !important;
                  height: 38px;
               }
            }
         }

         &_Container {
            margin-top: 20px;
         }

         &_pagenation {
            margin: 40px auto;
         }

         ::v-deep .el-table th,
         ::v-deep .el-table td {
            text-align: center !important;
         }
      }
   }

   .el-select {
      margin-bottom: 10px;
      margin-right: 10px;
   }

   .name-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 36px;
      margin-left: 10px;

      img {
         width: 25px;
         height: 25px;
      }
   }

   .button_code {
      display: flex;
      align-items: center;
      justify-content: center;

      .el-button--small, .el-button--small.is-round {
         padding: 11px 15px !important;
      }
   }
</style>